// These are flags that affect any user's experience inside a specific community
export enum CommunityFlags {
  EXAMPLE = "ExampleFlag",
  KNOWLEDGE_BASE = "KnowledgeBaseFlag",
  KNOWLEDGE_BASE_UI = "KnowledgeBaseUIFlag",
  COMMUNITY = "CommunityFlag",
  SEMANTIC = "SemanticFlag",
  SEARCH_V2 = "SearchV2Flag",
  LABELS = "LabelsFlag",
  VERSION_HISTORY = "VersionHistoryFlag",
  ANALYTICS = "AnalyticsFlag",
  SEARCH_AI = "SearchAIFlag",
  ASK_AI = "AskAIFlag",
  CATEGORY_CLICK_NAVIGATION = "CategoryClickNavigationFlag",
  WHITE_LABEL = "WhiteLabelFlag",
  DOCUMENT_FEEDBACK = "DocumentFeedbackFlag",
  CHANGELOG = "ChangelogFlag",
  TRUSTED_WORKSPACE = "TrustedWorkspaceFlag",
  WIDGET = "WidgetFlag",
  AI_SANDBOX = "AISandboxFlag",
  DOCS_WIDGET_FLAG = "DocsWidgetFlag",
  DOCS_WIDGET_TEAM_ONLY_FLAG = "DocsWidgetTeamOnlyFlag",
  FULL_PAGE_PROTOTYPE = "FullPagePrototypeFlag",
  MULTI_MODAL_AGENT_FLAG = "MultiModalAgentFlag",
  SANDBOX_MARKETING = "SandboxMarketingFlag",
  INTEGRATIONS = "IntegrationsFlag",
  REASONING_FLAG = "ReasoningFlag",
  CONVERSATION_FEEDBACK = "ConversationFeedbackFlag",
  INTENTS = "IntentsFlag",
  ZENDESK = "ZendeskFlag",
  DEBUG_SOURCES = "DebugSourcesFlag",
  ESCALATION_BUTTON_CONVERSATION = "EscalationButtonConversationFlag",
  ESCALATION_BUTTON_HOME = "EscalationButtonHomeFlag",
  ESCALATION = "EscalationFlag",
  ZENDESK_INSIGHTS = "ZendeskInsightsFlag",
}

// these are flags that affect a user's experience across all communities
export enum GlobalUserFlags {
  EXAMPLE = "ExampleFlag",
  REALTIME_UPDATES = "RealtimeUpdatesFlag",
}
